import { useState, useEffect } from "react";
import axios from "axios";
import { Apiurl } from "../../../shared/services/apirest";
import { getAuthHeader } from "../utils/investigadorUtils";

export const usePacientes = (activeProjectId) => {
    const [pacientes, setPacientes] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchPacientes = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${Apiurl}casos/pacientes/`, getAuthHeader());
            let data = res.data;
            if (activeProjectId) {
                data = data.filter(p => p.proyecto === activeProjectId);
            }
            setPacientes(data);
        } catch (err) {
            console.error("Error cargando pacientes:", err);
        } finally {
            setLoading(false);
        }
    };

    const deletePaciente = async (id) => {
        await axios.delete(`${Apiurl}casos/pacientes/${id}/`, getAuthHeader());
        setPacientes(prev => prev.filter(p => p.id !== id));
    };

    useEffect(() => {
        fetchPacientes();
    }, [activeProjectId]);

    return { pacientes, loading, fetchPacientes, deletePaciente };
};
